import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class SetBuyout {
  constructor(assetComponentId, buyout) {
    this.commandName = "SetBuyout";

    this.assetComponentId = assetComponentId;

    this.buyout = buyout;

    if (this.buyout == null) {
      this.description = `${i18n.t('CONTENT.events.no_buyout')}`
    } else if (this.buyout.isSure) {
      const convertedDate = dateConverter.convertToDate(this.buyout.date);
      const convertedPaymentDate = dateConverter.convertToDate(this.buyout.paymentDate);

      if(convertedPaymentDate === null) {
        this.description =
          `${i18n.t('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)}`;
      } else {
        this.description =
          `${i18n.t('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)} ${i18n.t('CONTENT.events.and_cost')} ${this.buyout.rate} ${this.buyout.currencyCode} ${i18n.t('CONTENT.events.on_date')} ${i18n.d(convertedPaymentDate)}`;
      }
    } else {
      this.description = `${i18n.$t('CONTENT.events.isNotSure')}`
    }




    // if (this.buyout == null) {
    //   this.description = `${i18n.t('CONTENT.events.no_buyout')}`
    // } else if (this.buyout.isSure) {
    //   const convertedDate = dateConverter.convertToDate(this.buyout.date);
    //   const convertedPaymentDate = dateConverter.convertToDate(this.buyout.paymentDate);
    //   this.description =
    //     `${i18n.t('CONTENT.events.isSureOnDate')} ${i18n.d(convertedDate)} ${i18n.t('CONTENT.events.and_buyoutDate')} ${this.buyout.rate} ${this.buyout.currencyCode} ${i18n.t('CONTENT.events.on_date')} ${i18n.d(convertedPaymentDate)}`
    // } else {
    //   this.description = `${i18n.t('CONTENT.events.isNotSure')}`
    // }

  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        Buyout: this.buyout
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
